import { useState, useEffect } from "react";
import { FaKey } from "react-icons/fa6";
import { NasService } from "../../../../../services/NasService";
import { InputDefault } from "../../../../../components/forms/InputDefault";
import { SelectPop } from "../../../../../components/forms/selects/SelectPop";
import { ModalWraper } from "../../../../../components/modal/wraper";

export const UpdateNasName = ({
  open,
  setOpen,
  refreshData,
  selectedNas // Data NAS yang dipilih
}) => {
  const [loading, setLoading] = useState(false);

  // Perbaikan 1: State objek JavaScript yang benar
  const [formData, setFormData] = useState({
    pop_id: "",
    name: ""
  });

  const [errorName, setErrorName] = useState(null);

  // Efek untuk mengisi form ketika modal dibuka atau data selectedNas berubah
  useEffect(() => {
    if (open && selectedNas) {
      setFormData({
        pop_id: selectedNas?.pop?.id || "",
        // Sesuaikan dengan field shortname/name dari backend
        name: selectedNas?.shortname || selectedNas?.name || ""
      });
      setErrorName(null);
    } else if (!open) {
      setFormData({
        pop_id: "",
        name: ""
      });
      setErrorName(null);
    }
  }, [open, selectedNas]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validasi sederhana
    if (!formData.name.trim()) {
      setErrorName("Nama NAS tidak boleh kosong");
      return;
    }

    setLoading(true);
    setErrorName(null);

    try {
      // Mengirim pop_id dan name sesuai ekspektasi controller Laravel
      await NasService.updateName({
        id: selectedNas.id,
        data: {
          pop_id: formData.pop_id,
          name: formData.name
        }
      });

      setOpen(false);
      refreshData();
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Gagal mengupdate NAS");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWraper
      isOpen={open}
      setIsOpen={setOpen}
      title="Update Data NAS"
    >
      <form onSubmit={handleSubmit} className="space-y-5">

        <SelectPop
          id={"pop_id"}
          label={"Pilih Pop"}
          placeholder={"Pilih Pop"}
          value={formData.pop_id}
          setValue={(val) => setFormData((prev) => ({ ...prev, pop_id: val }))}
          searchable={true}
        />

        <InputDefault
          id={"name"}
          label={"Nama NAS"}
          type={"text"}
          placeholder={"Masukkan nama NAS (misal: Mikrotik 01)"}
          value={formData.name}
          onChange={(e) => {
            setFormData((prev) => ({ ...prev, name: e.target.value }));
            if (errorName) setErrorName(null);
          }}
          disabled={loading}
          error={errorName}
        />

        {/* Tombol Aksi */}
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 font-medium hover:bg-slate-800/50 transition-colors"
          >
            Batal
          </button>

          <button
            type="submit"
            disabled={loading}
            className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 disabled:text-slate-500 text-white font-semibold flex items-center justify-center gap-2 transition-all shadow-lg shadow-cyan-900/20"
          >
            {loading ? (
              <>Menyimpan...</>
            ) : (
              <>
                <FaKey />
                Simpan
              </>
            )}
          </button>
        </div>
      </form>
    </ModalWraper>
  );
};